import { createContext, useContext, type ReactNode } from 'react';

/** 도메인 모티프별 윈도우 chrome variant. DesktopWindow와 동일 type 별칭. */
export type WindowChromeVariant = 'default' | 'dailySealedLog' | 'operatorConsole';

export interface WindowConfig {
  id: string;
  title: string;
  defaultX: number;
  defaultY: number;
  defaultWidth: number;
  defaultHeight: number;
  minWidth: number;
  minHeight: number;
  render: () => ReactNode;
  /** TitleBar 영역 motif title 주입 ReactNode (titleSlot). 미주입 시 title string fallback. */
  titleSlot?: ReactNode;
  /** 모바일 테이크오버 제목 앞자리 ReactNode (leadingSlot). 데스크톱 창에는 그리지 않는다. */
  mobileLeadingSlot?: ReactNode;
  /** windowContent 아래 footer band ReactNode (footerSlot). 미주입 시 footer band 자체 안 그림. */
  footerSlot?: ReactNode;
  /** Chrome variant — 도메인 모티프 적용 시 frame border/scan-line/titleBar 톤 분기. */
  variant?: WindowChromeVariant;
  /**
   * 윈도우 래퍼 chrome 선택. 미지정 시 'desktop' (DesktopWindow).
   * 'holopane' — AR projected surface 래퍼 (react-rnd 기반). 전체 전환의 파일럿 진입점.
   */
  wrapper?: 'desktop' | 'holopane';
}

export const WindowRegistryContext = createContext<WindowConfig[]>([]);

export function useWindowRegistry(): WindowConfig[] {
  return useContext(WindowRegistryContext);
}
